<template>
  <v-main class="sm-max-p-0 sm-and-down-mt-56">
    <v-app-bar
      v-for="(notification, i) in getAgentNotifications"
      :key="i"
      color="black"
      dark
      min-height="80"
      class="pt-2"
    >
      <v-container>
        <v-row align="center">
          <div class="sm-and-down-w-100 text-truncate">
            <h3 class="text-truncate">
              {{ notification.text }}
            </h3>
            <p class="mb-0 hidden-sm-and-down">
              <strong></strong>
            </p>
          </div>
          <v-spacer />
          <v-btn
            :to="{
              name: 'tickets',
              query: {
                inmediate_attention: true,
              },
            }"
            color="accent"
            class="hidden-sm-and-down black--text"
            rounded
          >
            Ver oportunidades
          </v-btn>
          <v-btn color="accent" class="hidden-md-and-up black--text" x-small rounded> Ver oportunidades </v-btn>
        </v-row>
      </v-container>
    </v-app-bar>
  </v-main>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "NotificationsBanner",
  computed: {
    ...mapGetters(["getAgentNotifications"]),
  },
};
</script>
